module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/flow-image02-bcef25527037efb4a8b7d1acb0eb9b98.png";